import React, {useContext} from 'react';
import { authContext } from '../Login/AuthContext';
import ComposeArea from './Areas/ComposeArea.js';
import { Link } from 'react-router-dom'
import "../config/global.js"
import "./config.js"

const Zones = () => {
  const { auth } = useContext(authContext);
  const { setAuthData } = useContext(authContext);

  if(auth.data.zones){
    var old = null;
      return (
      <>
        <div className="row-cols-1" style={{marginTop:'50px'}}>
            &nbsp;
        </div>
        <div className="col-4 text-left" style={{float:'left'}}>
          <h1>{global.zone_name}</h1>
          <ul>{
          auth.data.zones.map((zone,i) => {
            if (old !== zone.Zone){
              old = zone.Zone;
              return (
                <div key={"div"+i}>
                  <li key={"li"+zone.Zone}><b>{zone.Zone}</b></li>
                  <li key={"li"+i}>
                    <Link to="/Booking/Ventilation" onClick={() => {
                      auth.data.zone = zone;
                      setAuthData(auth.data);
                    }}>{zone.name}</Link>
                  </li>
                </div>
              )
            } else
              return (
                <li key={"li"+i}>
                  <Link to="/Booking/Ventilation" onClick={() => {
                    auth.data.zone = zone;
                    setAuthData(auth.data);}}>{zone.name}</Link>
                </li>
              )
          })}
          </ul>
        </div>
        <div className="col-8" style={{float:'left'}}>
            <ComposeArea/>
        </div>
    </>
      );
  }else
      return (<div>No zones available</div>)
};

export default Zones;
